<template>
  <div class="wrapper">
    <link rel="stylesheet" href="//fonts.googleapis.com/icon?family=Material+Icons"/>
    <link href="../screen.css" rel="stylesheet" type="text/css"></link>
    <link href="../extend-screen.css" rel="stylesheet" type="text/css"></link>
    <link href="../main.css" rel="stylesheet" type="text/css"></link>
    
    <h1>型番一覧入力</h1>
    <br/><br/>
    <div>
      型番 数量(空白区切り)
      <span style="padding-left:190px;">
	<a href="javascript:" class="link-right" @click="goCheck" style="color: #3673ac;"
	   onmouseover="this.style.color='#ff7f50'"
	   onmouseout="this.style.color='#3673ac'">確認</a>
	<a v-if="this.$props.debug" href="javascript:" class="link-right" @click="goSelect(false)">詳細選択へ</a>
	<a v-if="this.$props.debug" href="javascript:" class="link-right" @click="goSelect(true)">インストール設定へ</a>
      </span>
    </div>
    <textarea name="koseiList" rows="20" cols="50" wrap="off" 
	      v-model="koseiList"></textarea>
    <div style="width:500px;">※ 「必ず標準コンフィグレータで構成を組み、カートに入れてください」というエラーとなった製品は型番一覧入力からはカートに入れられません。標準コンフィグレータをお使いください
    <br/>※カート導入後の構成編集は、下記製品のみ対応しております。
    <ul style="margin:0;">
      <li style="margin:0;padding:0;">ワークステーション</li>
      <li style="margin:0;padding:0;">PCサーバ</li>
    </ul>
    </div>
    
    <!-- <div>
      <md-input-container>
	<label>型番 数量(空白区切り)</label>
	<md-textarea style="background-color:white;"  rows="100" md-autogrow="true"></md-textarea>
      </md-input-container>
    </div> -->

    <div v-if="serverError">
      <dl class="error">
	<dt>通信エラーが発生しました</dt>
	<dd></dd>
      </dl>
    </div>
    
    <div v-if="error || warning">
      <div style="text-align:right;">
	<a v-if="warning" href="javascript:" class="link-right" @click="goNext" style="color: #3673ac;"
	   onmouseover="this.style.color='#ff7f50'"
	   onmouseout="this.style.color='#3673ac'">次へ</a>
      </div>
      <dl class="error" v-if="error">
	<dt>構成にエラーがあります</dt>
	<dd>もう一度型番をご確認の上入力してください。</dd>
      </dl>
      <dl class="warning" v-if="warning && !error">
	<dt>警告項目がありますのでご確認ください</dt>
	<dd>メッセージ欄の内容をご確認の上「次へ」をクリックしてください</dd>
      </dl>
      <table class="border" width="100%" summary>
	<tbody>
	  <tr>
	    <th>項番</th>
	    <th>型番</th>
	    <th>数量</th>
	    <th>組込項番</th>
	    <th>カート項番</th>
	    <th>メッセージ</th>
	  </tr>
	  <tr v-for="c,i in res">
	    <td v-bind:class="(c.error_cd==1)? 'err-cell' : (c.error_cd==2)? 'war-cell': null">{{ c.koban }}</td>
	    <td v-bind:class="(c.error_cd==1)? 'err-cell' : (c.error_cd==2)? 'war-cell': null">{{ c.hinmei_cd }}</td>
	    <td v-bind:class="(c.error_cd==1)? 'err-cell' : (c.error_cd==2)? 'war-cell': null">{{ c.suryo }}</td>
	    <td v-bind:class="(c.error_cd==1)? 'err-cell' : (c.error_cd==2)? 'war-cell': null">{{ c.kumikomi_koban }}</td>
	    <td v-bind:class="(c.error_cd==1)? 'err-cell' : (c.error_cd==2)? 'war-cell': null">{{ c.kosei_id }}</td>
	    <td v-bind:class="(c.error_cd==1)? 'err-cell' : (c.error_cd==2)? 'war-cell': null">
	      <template v-for="m in c.error_mes.split(/\t/)">
		{{ m }} <br/>
	      </template>
	    </td>
	  </tr>
	</tbody>
      </table>
    </div>

    <form name="goNext" method="POST" action="../CodeInput.action">
      <!--
      <input type="hidden" name="kosei_id" :value="param.kosei_id" _value="1,1,1,1,1,1,1,1,1,1,1,1,1"/>
      <input type="hidden" name="koban" :value="param.koban" _value="1,2,3,4,5,6,7,8,9,10,11,12,13"/>
      <input type="hidden" name="kumikomi_koban" :value="param.kumikomi_koban" _value="1,1,1,1,1,1,1,1,1,1,1,1,1"/>
      <input type="hidden" name="hinmei_cd" :value="param.hinmei_cd" _value="N8100-3004Y,K410-538(00),K410-E246(03),N8101-1873,N8102-764,N8103-218,N8103-243,N8116-116,N8150-1825,N8151-137,N8154-187,N8181-159,UL1908-00D1"/>
      <input type="hidden" name="suryo" :value="param.suryo" _value="1,1,2,1,1,1,1,1,1,1,1,2,1"/>
      <input type="hidden" name="rkosei_cd" :value="param.rkosei_cd" _value=",,,,,,,,,,,,"/>
      <input type="hidden" name="para1" :value="param.para1" _value=",,,,,,,,,,,,"/>
      <input type="hidden" name="para2" :value="param.para2" _value=",,,,,,,,,,,,"/>
      <input type="hidden" name="para3" :value="param.para3" _value=",,,,,,,,,,,,"/>
      <input type="hidden" name="sub_system" :value="param.sub_system" _value=",,,,,,,,,,,,"/>
      <input type="hidden" name="config_flag" :value="param.config_flag" _value="0,0,0,0,0,0,0,0,0,0,0,0,0"/>
      <input type="submit"/>
      -->
      <input type="hidden" name="kosei_id" value="1,1,1,1,1,1,1,1,1,1,1,1,1"/>
      <input type="hidden" name="koban" value="1,2,3,4,5,6,7,8,9,10,11,12,13"/>
      <input type="hidden" name="kumikomi_koban" value="1,1,1,1,1,1,1,1,1,1,1,1,1"/>
      <input type="hidden" name="hinmei_cd" value="N8100-3004Y,K410-538(00),K410-E246(03),N8101-1873,N8102-764,N8103-218,N8103-243,N8116-116,N8150-1825,N8151-137,N8154-187,N8181-159,UL1908-00D1"/>
      <input type="hidden" name="suryo" value="1,1,2,1,1,1,1,1,1,1,1,2,1"/>
      <input type="hidden" name="rkosei_cd" value=",,,,,,,,,,,,"/>
      <input type="hidden" name="para1" value=",,,,,,,,,,,,"/>
      <input type="hidden" name="para2" value=",,,,,,,,,,,,"/>
      <input type="hidden" name="para3" value=",,,,,,,,,,,,"/>
      <input type="hidden" name="sub_system" value=",,,,,,,,,,,,"/>
      <input type="hidden" name="config_flag" value="0,0,0,0,0,0,0,0,0,0,0,0,0"/>
    </form>

    <form id="goSelect" name="goSelect" method="POST" action="../CodeSelect.action">
      <input type="hidden" name="base" value=""/>
      <!-- <input type="hidden" name="option" value=""/> -->
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'

export default {
    props: {
	debug: {
	    type: Boolean,
	    default: false,
	    required: false,
	},
	session: {
	    type: Boolean,
	    default: false,
	    required: false,
	}
    },
    data() {
	return {
	    koseiList: '',
	    res: [],
	    error: false,
	    warning: false,
	    serverError: false,
	    param: {
	    	kosei_id: '',
		koban: '',
		kumikomi_koban: '',
		hinmei_cd: '',
		suryo: '',
		rkosei_cd: '',
		para1: '',
		para2: '',
		para3: '',
		sub_system: '',
		config_flag: ''
	    }
	};
    },
    methods: {
	goCheck() {
	    if(this.koseiList.trim().length < 1) {
		alert('型番 数量を入力してください')
		return
	    }

	    console.log(this.koseiList);

	    window.sessionStorage.setItem('koseiList',this.koseiList);
	    
	    this.serverError=false;
	    // axios.get('static/codeInputCheckResult.json',{
	    // })
	    axios.post('../CodeInputCheck.action',qs.stringify({
		koseiList: this.koseiList
	    }), { headers: {  // formデータとして送信
		'Contenxt-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
	    }})
		.then( res => {
		    console.log(res.data);
		    
		    this.res = res.data ;
		    this.error = false;
		    this.warning = false;
		    let kumiko = 0;
		    for(let i=0; i<this.res.length; i++) {
			console.log(this.res[i]);
			if(this.res[i].error_cd == 1) { //エラー表示へ
			    this.error=true;
			    //console.log('エラー表示へ');
			    //this.showError();
			    return;
			}
			if(this.res[i].error_cd > 1) this.warning = true;

			kumiko = this.res[i].kumikomi_koban;
			if(!kumiko)  kumiko = '';
			
			//this.error=false;
			if(i==0) {
			    this.param.kosei_id = this.res[i].kosei_id;
			    this.param.koban = this.res[i].koban;
			    this.param.kumikomi_koban = kumiko
			    this.param.hinmei_cd = this.res[i].hinmei_cd;
			    this.param.suryo = this.res[i].suryo;
			    this.param.rkosei_cd = '';
			    this.param.para1 = '';
			    this.param.para2 = '';
			    this.param.para3 = '';
			    this.param.sub_system = '';
			    this.param.config_flag= '0';
			} else {
			    this.param.kosei_id += ',' + this.res[i].kosei_id;
			    this.param.koban += ',' + this.res[i].koban;
			    this.param.kumikomi_koban += ',' + kumiko;
			    this.param.hinmei_cd += ',' + this.res[i].hinmei_cd;
			    this.param.suryo += ',' + this.res[i].suryo;
			    this.param.rkosei_cd += ',';
			    this.param.para1 += ',';
			    this.param.para2 += ',';
			    this.param.para3 += ',';
			    this.param.sub_system += ',';
			    this.param.config_flag += ',0';
			}
		    }
		    //エラーなし
		    //console.log(this.param);
		    //console.log(document.goNext);
		    if(!this.warning)  this.goNext();
		})
		.catch( err => {
		    console.log(err);
		    this.serverError = true;
		});
		    
	},
	goNext() {
	    document.goNext.kosei_id.value = this.param.kosei_id;
	    document.goNext.koban.value = this.param.koban;
	    document.goNext.kumikomi_koban.value = this.param.kumikomi_koban;
	    document.goNext.hinmei_cd.value = this.param.hinmei_cd;
	    document.goNext.suryo.value = this.param.suryo;
	    document.goNext.rkosei_cd.value = this.param.rkosei_cd;
	    document.goNext.para1.value = this.param.para1;
	    document.goNext.para2.value = this.param.para2;
	    document.goNext.para3.value = this.param.para3;
	    document.goNext.sub_system.value = this.param.sub_system;
	    document.goNext.config_flag.value = this.param.config_flag;
	    console.log(document.goNext);
	    document.goNext.submit();
	},
	//showError() {
	//    
	//},
	goSelect(isSetup) {
	    window.sessionStorage.setItem('koseiList',this.koseiList);
	    let lines = this.koseiList.split('\n')
	    let base, options = []
	    lines.forEach((line, idx) => {
		if('' == line.trim()) return; //next
		let col = line.split(/\s+/)
		//console.log(col)
		if(idx==0) base = col[0];
		else {
		    if(col.length > 1)
			for(let i=0; i<col[1]; i++) {
			    //console.log(col[0]);
			    options.push(col[0])
			}
		    else
			options.push(col[0])
		}
	    })
	    console.log('base:',base);
	    console.log('options:',options);
	    document.goSelect.base.value = base;
	    let el = document.getElementById('goSelect');
	    for(let i=0; i<options.length; i++) 
		el.innerHTML += `<input type="hidden" name="option" value="${options[i]}" />`;
	    if(isSetup)  document.goSelect.action = '../CodeToSetup.action'
	    document.goSelect.submit();
	}
    },
    beforeMount() {
	document.title = "型番一覧入力";

	//console.log("session: ", this.$props.session);
	if(this.$props.session) {
	    let k;
	    if(k = window.sessionStorage.getItem('koseiList')) {
		this.koseiList = k;
	    }
	}
    }
}
</script>
<style>
#main {
  text-align: left;
  background-color: #ece0c4;
}
#main input:disabled {
  color: black;
  background-color: white;
}
.warning{border:1px solid #593D00; background:url(../../static/icon_warning.gif) no-repeat 5px center; padding:5px 5px 5px 42px;color:#593D00;}
						  
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
							    }
							    
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-out .5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce-out {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(0);
  }
}
.border td.err-cell { background-color: #FCC;}
.border td.war-cell { background-color: #FEB;}

</style>





// WEBPACK FOOTER //
// CodeInput.vue?5fe3a767